<div class="mx-auto max-w-screen-md">
	<div
		[attr.data-test-id]="subjectTestId()"
		[editableInStoryblok]="_editable()"
		class="card card-form"
	>
		@if (requestSubmitted()) {
			<vp-alert
				[content]="successContent()"
				[emphasized]="true"
				[title]="successTitle()"
				data-test-id="alert"
				type="dialog--success"
			/>
		}
		<form
			#formRef="ngForm"
			[class]="cn(requestSubmitted() && 'hidden')"
			[formGroup]="formGroup"
			(ngSubmit)="onSubmit()"
		>
			<formly-form
				[fields]="formFields()"
				[form]="formGroup"
				[model]="model"
				[options]="options"
			/>
			<button
				[class]="
					cn(
						'btn mt-6 w-full btn-primary md:mt-8',
						requestSubmitting() && 'btn-is-loading'
					)
				"
				[disabled]="requestSubmitting()"
				data-test-id="request-button"
				type="submit"
			>
				{{ buttonText() }}
			</button>
			<div class="mt-3 md:mt-4">
				<vp-recaptcha-notification [currentLanguage]="language()" />
			</div>
		</form>
		@if (requestSubmitted()) {
			<div class="mt-4 md:mt-6">
				@for (field of parsedFormData(); track field.id) {
					<span class="block font-bold"> {{ field.label }} </span>
					<span class="block whitespace-pre-line">
						{{ field.value }}
					</span>
				}
				<button
					(click)="resetForm()"
					class="mt-6 text-link md:mt-8"
					data-test-id="summary-action"
					type="button"
				>
					{{ 'storyblok.giftcard.send-another-request' | translate }}
				</button>
			</div>
		}
	</div>
</div>
